const BASE_URL = process.env.REACT_APP_API_URL || "https://panel.balto.com.ar/api/routes";

export default BASE_URL;


//Hostinger produccion: https://panel.balto.com.ar/api/routes

//Local: http://localhost:3001/routes
